// extracted by mini-css-extract-plugin
export var box = "_24-1";
export var checkboxRow = "_24-8";
export var checked = "_24-2";
export var descriptionSpacer = "_24-a";
export var disabled = "_24-3";
export var icon = "_24-6";
export var input = "_24-0";
export var labelSpacer = "_24-9";
export var medium = "_24-5";
export var small = "_24-4";
export var text = "_24-7";